"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SENTRY_XHR_DATA_KEY", {
  enumerable: true,
  get: function () {
    return _xhr.SENTRY_XHR_DATA_KEY;
  }
});
Object.defineProperty(exports, "addClickKeypressInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _dom.addClickKeypressInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addClsInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _instrument.addClsInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addFidInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _instrument.addFidInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addHistoryInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _history.addHistoryInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addInpInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _instrument.addInpInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addLcpInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _instrument.addLcpInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addPerformanceEntries", {
  enumerable: true,
  get: function () {
    return _browserMetrics.addPerformanceEntries;
  }
});
Object.defineProperty(exports, "addPerformanceInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _instrument.addPerformanceInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addTtfbInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _instrument.addTtfbInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addXhrInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _xhr.addXhrInstrumentationHandler;
  }
});
Object.defineProperty(exports, "clearCachedImplementation", {
  enumerable: true,
  get: function () {
    return _getNativeImplementation.clearCachedImplementation;
  }
});
Object.defineProperty(exports, "extractNetworkProtocol", {
  enumerable: true,
  get: function () {
    return _utils.extractNetworkProtocol;
  }
});
Object.defineProperty(exports, "fetch", {
  enumerable: true,
  get: function () {
    return _getNativeImplementation.fetch;
  }
});
Object.defineProperty(exports, "getNativeImplementation", {
  enumerable: true,
  get: function () {
    return _getNativeImplementation.getNativeImplementation;
  }
});
Object.defineProperty(exports, "registerInpInteractionListener", {
  enumerable: true,
  get: function () {
    return _inp.registerInpInteractionListener;
  }
});
Object.defineProperty(exports, "setTimeout", {
  enumerable: true,
  get: function () {
    return _getNativeImplementation.setTimeout;
  }
});
Object.defineProperty(exports, "startTrackingINP", {
  enumerable: true,
  get: function () {
    return _inp.startTrackingINP;
  }
});
Object.defineProperty(exports, "startTrackingInteractions", {
  enumerable: true,
  get: function () {
    return _browserMetrics.startTrackingInteractions;
  }
});
Object.defineProperty(exports, "startTrackingLongAnimationFrames", {
  enumerable: true,
  get: function () {
    return _browserMetrics.startTrackingLongAnimationFrames;
  }
});
Object.defineProperty(exports, "startTrackingLongTasks", {
  enumerable: true,
  get: function () {
    return _browserMetrics.startTrackingLongTasks;
  }
});
Object.defineProperty(exports, "startTrackingWebVitals", {
  enumerable: true,
  get: function () {
    return _browserMetrics.startTrackingWebVitals;
  }
});

var _instrument = require("./metrics/instrument.js");

var _browserMetrics = require("./metrics/browserMetrics.js");

var _utils = require("./metrics/utils.js");

var _dom = require("./instrument/dom.js");

var _history = require("./instrument/history.js");

var _getNativeImplementation = require("./getNativeImplementation.js");

var _xhr = require("./instrument/xhr.js");

var _inp = require("./metrics/inp.js");